"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceItem = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

require("./template-1-service-item.css");

function ServiceItem(_ref) {
  var serviceImageUrl = _ref.serviceImageUrl,
      title = _ref.title,
      content = _ref.content;
  return react_1.default.createElement("div", {
    className: "h-full md:flex xs:grid xs:gap-1 px-6 py-6 service-item bg-white-200 hover:bg-gray-200"
  }, react_1.default.createElement("div", {
    className: "md:w-1/2 xs:2-fill grid md:grid-cols-6 xs:grid-cols-1 items-center"
  }, serviceImageUrl && react_1.default.createElement("div", {
    className: "col-span-1"
  }, react_1.default.createElement("span", {
    className: "icon-wrapper flex justify-center items-center"
  }, react_1.default.createElement("img", {
    src: serviceImageUrl,
    alt: "card-icon"
  }))), react_1.default.createElement("div", {
    className: "col-span-5 pl-3 xs:mt-4 md:mt-0"
  }, react_1.default.createElement("h3", {
    className: "text-center md:text-left text-2xl"
  }, title))), react_1.default.createElement("div", {
    className: "md:w-1/2 xs:w-full grid md:grid-cols-6 xs:grid-cols-1 xs:mt-5 md:mt-0"
  }, react_1.default.createElement("div", {
    className: "col-span-6 items-center flex justify-center"
  }, react_1.default.createElement("div", {
    className: "items-center text-center md:text-left text-base"
  }, content))));
}

exports.ServiceItem = ServiceItem;
ServiceItem.propTypes = {
  serviceImageUrl: prop_types_1.default.string,
  title: prop_types_1.default.string,
  content: prop_types_1.default.string // icons: propTypes.bool,

};
ServiceItem.defaultProps = {
  title: 'Title',
  content: 'ABC' // icons: true,

};